export default {
	productionControlDetailMainTitle: 'Kontrola produkce - Detail případu',
	documentInfo: 'Informace o dokumentu',
	consultantInfo: 'Informace o poradci',
	documentUploadWave: 'Vlna nahrání dokumentů',
	documentType: 'Typ dokumentu',
	solverName: 'Jméno a příjmení poradce',
	solverSellerIn: 'Získatelské číslo',
	superiorName: 'Jméno a příjmení nadřízeného',
	notice: 'Vyjádření',
	noticeByCentral: 'Vyjádření centrála',
	documentState: 'Stav',
	centralConsent: 'Souhlas centrála',
	noticeFullName: 'Příjmení a jméno',
	noticeDateCreated: 'Datum',
	documentStateAlert: 'Výsledek kontroly: ',
	policyHolder: 'Pojistník',
	backButtonText: 'Zpět na kontrolu produkce',
};
